import { render, staticRenderFns } from "./DashboardEquipes.vue?vue&type=template&id=c59842ce"
import script from "./DashboardEquipes.vue?vue&type=script&lang=js"
export * from "./DashboardEquipes.vue?vue&type=script&lang=js"
import style0 from "./DashboardEquipes.vue?vue&type=style&index=0&id=c59842ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports